module.exports = __webpack_public_path__ + "static/img/weather_sunnytocloudy.61eb32e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather_sunnytocloudy.png
// module id = QbYi
// module chunks = 2